import React, { useState } from "react";
import styled from "styled-components";
import { Paginator } from "primereact/paginator";
import { SmallHadding } from "molecules/SmallHeadding";
import { DetailBox } from "../../molecules/DetailBox";

const CustPaginator = styled(Paginator)`
  .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
    color: #000;
  }
  .p-paginator-pages {
    margin: 0 1rem;
  }
  .p-paginator-pages .p-paginator-page.p-highlight {
    background: #010101;
    border-color: #010101;
    color: #fff;
    cursor: default;
  }
  .p-paginator-pages .p-paginator-page {
    border: none;
    border-radius: 50% !important;
    color: #010101;
    float: left;
    font-size: 18px;
    font-weight: 500;
    height: 2pc;
    line-height: 2pc;
    min-width: 2pc;
    padding: 0 !important;
    text-align: center;
    text-decoration: none;
  }
  .p-paginator-pages .p-paginator-page:hover {
    background: #010101;
    color: #fff;
    text-decoration: none;
  }
`;

const ItemTag = styled.div`
  .cust-title {
    font-size: 20px !important;
  }
  .cust-title:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const PeopleSliderContainer = styled.div`
  padding: 0;
`;

const PeopleSlider = ({ data }) => {
  const [first, setFirst] = useState(0);
  const rows = 8; // Number of items per page

  const onPageChange = (event) => {
    setFirst(event.first);
  };

  // Get current page data
  const currentPageData = data?.slice(first, first + rows);

  const itemTemplate = (item) => (
      <ItemTag
        className="grid grid-cols-1 sm:grid-cols-2 lg:col-3 text-justify pl-0 mobileMargin"
        id={
          item?.id != null && item?.id !== ""
            ? `person-${item.id}`
            : undefined
        }
      >
      {item?.image ? (
        <div className="p-0 peopleImage my-1">
          <img
            src={`${item?.image}`}
            alt={item?.name}
            style={{
              aspectRatio: "1/1",
              objectFit: "cover",
              marginBottom: "5px",
              padding: 0,
              width: "100%",
              height: "auto",
            }}
          />
        </div>
      ) : null}
      <div className="my-1 peopleImage peopleImageText">
        <SmallHadding
          text={item?.name}
          className="pt-0 cust-title font-base font-medium text-left no-underline"
        />
        <DetailBox
          details={item?.position}
          style={{ fontSize: 17 }}
          className="my-1 text-left"
        />
      </div>
    </ItemTag>
  );

  return (
    <PeopleSliderContainer data-aos="fade-up">
      <div className="container pl-0 pr-0">
        <div className="grid">
          {currentPageData?.map((item) => itemTemplate(item))}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        <div className="-mb-3">
          <CustPaginator
            first={first}
            rows={rows}
            totalRecords={data?.length}
            rowsPerPageOptions={[rows]}
            onPageChange={onPageChange}
            prevPageLinkIcon={
              <i
                className="pi pi-arrow-circle-left"
                style={{ fontSize: "2rem" }}
              ></i>
            }
            nextPageLinkIcon={
              <i
                className="pi pi-arrow-circle-right"
                style={{ fontSize: "2rem" }}
              ></i>
            }
            currentPageReportTemplate="{currentPage} of {totalPages}"
            template={{ layout: "PrevPageLink CurrentPageReport NextPageLink" }}
          />
        </div>
      </div>
    </PeopleSliderContainer>
  );
};

export default PeopleSlider;
